import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatTableDataSource } from "@angular/material/table";
import { TableColumnType } from "src/app/constants/table";
import { ReportParamterType } from "src/app/constants/wizard-panels";
import { ParameterPaylod, ParameterDetail, ReportWizardParameters } from "src/app/models/reports";
import { TableColumn } from "src/app/models/table";
import { FormValidationService } from "src/app/services/form-validation.service";

@Component({
    selector: 'mwp-report-builder-parameters',
    templateUrl: './report-builder-parameters.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReportBuilderParametersComponent implements OnInit, OnChanges {
    @Input() public reportWizardParameters: ReportWizardParameters;

    @Output() public emitCancel: EventEmitter<any> = new EventEmitter();
    @Output() public emitSave: EventEmitter<ParameterPaylod> = new EventEmitter();

    public parameterForm: FormGroup;
    public caption: string;
    public parameterWizardName: string;
    public ReportParamterType = ReportParamterType
    public parameterFormCheckboxSelect: string = 'selected';
    public openEnrollmentFormArrayName: string = 'openEnrollmentFormArrayName';
    public dateWizardValue: string = 'dateWizardValue';

    public reportMatTableData: MatTableDataSource<ParameterDetail>;
    public reportColumns: TableColumn[];

    public displayDate: boolean;
    public displayBenefitCatgory: boolean;
    public displayOpenEnrollment: boolean;

    constructor(
        private formBuilder: FormBuilder,
    ) {
    }

    ngOnInit(): void {
        this.loadForm();
    }

    ngOnChanges(): void {
        this.loadForm();
    }

    private loadForm(): void {
        if (this.parameterWizardName != this.reportWizardParameters.name) {
            this.parameterWizardName = this.reportWizardParameters.name;
            this.parameterForm = null;

            this.reportColumns = [
                {
                    propertyId: this.parameterFormCheckboxSelect,
                    columnName: '',
                    columnType: this.reportWizardParameters.parameterDetailsSingleSelect ? TableColumnType.checkBox : TableColumnType.checkBoxSelectAll,
                    width: '8%'
                },
                {
                    propertyId: 'description',
                    columnName: 'Enrollment',
                    columnType: TableColumnType.label,
                },
            ];

            this.caption = this.reportWizardParameters.caption;

            switch (this.reportWizardParameters.name) {
                case ReportParamterType.benefitCategories:
                case ReportParamterType.openEnrollment:
                    if (this.reportWizardParameters.name == ReportParamterType.benefitCategories)
                        this.displayBenefitCatgory = true;
                    else
                        this.displayOpenEnrollment = true;

                    this.caption = this.reportWizardParameters.caption;
                    this.reportMatTableData = new MatTableDataSource<ParameterDetail>();
                    this.reportMatTableData.data = this.reportWizardParameters.parameterDetails;

                    let l_FormArray: FormArray = new FormArray([], this.reportWizardParameters.isRequird ? FormValidationService.formArrayRequiresCheckboxChecked(this.parameterFormCheckboxSelect) : null);
                    if (this.reportMatTableData.data != null || this.reportMatTableData.data.length > 0) {
                        this.reportMatTableData.data.forEach((detail: ParameterDetail) => {
                            l_FormArray.push(
                                this.formBuilder.group({
                                    [this.parameterFormCheckboxSelect]: [detail.selected],
                                    description: [detail.description],
                                    id: [detail.value],
                                })
                            );
                        });
                    }

                    this.parameterForm = this.formBuilder.group({
                        [this.openEnrollmentFormArrayName]: l_FormArray,
                    });
                    break;

                case ReportParamterType.date:
                    this.displayDate = true;
                    this.displayOpenEnrollment = false
                    this.parameterForm = this.formBuilder.group({
                        [this.dateWizardValue]: [null, this.reportWizardParameters.isRequird ? [Validators.required, Validators.compose([FormValidationService.validMaterialDate(true, true)])] : null],
                    });
                    break;
            }
        }
    }

    public cancel(): void {
        this.emitCancel.emit();
    }

    public save(): void {
        const l_ParameterPaylod: ParameterPaylod = new ParameterPaylod();
        l_ParameterPaylod.reportParameterID = this.reportWizardParameters.parameterID;

        switch (this.reportWizardParameters.name) {
            case ReportParamterType.openEnrollment:
            case ReportParamterType.benefitCategories:
                const l_AssignArray = <FormArray>this.parameterForm.get(this.openEnrollmentFormArrayName) as FormArray;
                l_AssignArray.controls.map((gaa) => {
                    if (gaa.get(this.parameterFormCheckboxSelect).value) {
                        l_ParameterPaylod.selectedValue = gaa.get('id').value;
                    }
                });
                break;
            case ReportParamterType.date:
                // Short Date
                l_ParameterPaylod.selectedValue = this.parameterForm.get(this.dateWizardValue).value.toISOString().split('T')[0];
                break;
        }

        this.emitSave.emit(l_ParameterPaylod);
    }
}